import http from "@http"
//角色列表  不分页
export function getDictTypeAll(data) {
    return http({
        url: '/lskj-admin/api/admin/dictType/all',
        method: "post",
        data
    })
}
//角色列表  分页
export function getDictTypeList(data) {
    return http({
        url: '/lskj-admin/api/admin/dictType/list',
        method: "post",
        data
    })
}

//查询单条角色信息
export function dictTypeById(data) {
    return http({
        url: `/lskj-admin/api/admin/dictType/byId?id=${data.id}`,
        method: "get",
    })
}

//添加部门
export function dictTypeAdd(data) {
    return http({
        url: '/lskj-admin/api/admin/dictType/add',
        method: "post",
        data
    })
}

//修改部门信息
export function updeteDictType(data) {
    return http({
        url: `/lskj-admin/api/admin/dictType`,
        method: "put",
        data
    })
}
//删除部门信息
export function deleteDictType(data) {
    return http({
        url: `/lskj-admin/api/admin/dictType?ids=${data.ids}`,
        method: "delete",
        data
    })
}
